import { provideWidgetClass } from 'scrivito'

export const BreadcrumbWidget = provideWidgetClass('BreadcrumbWidget', {})
